import { render, staticRenderFns } from "./appbanneradvertiserManageAdd.vue?vue&type=template&id=37448882&scoped=true"
import script from "./appbanneradvertiserManageAdd.vue?vue&type=script&lang=js"
export * from "./appbanneradvertiserManageAdd.vue?vue&type=script&lang=js"
import style0 from "./appbanneradvertiserManageAdd.vue?vue&type=style&index=0&id=37448882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37448882",
  null
  
)

export default component.exports